/**
 * @description 存储sessionStorage
 * @param {存储的keyName} name
 * @param {存储的值} value
 */
export const setStorage = (name, value) => {
    if (!name) {
        return false
    }
    let data = typeof value !== 'string' ? JSON.stringify(value) : value
    window.sessionStorage.setItem(name, data)
}

/**
 * @description 读取sessionStorage
 * @param {存储的keyName} name
 */
export const getStorage = (name) => {
    if (!name) {
        return false
    }
    let data = window.sessionStorage.getItem(name)
    if (data) {
        return data
    } else {
        return null
    }
}

/**
 * @description 删除sessionStorage
 * @param {需要删除的keyName} name
 */
export const removeStorage = (name) => {
    if (!name) {
        return false
    }
    window.sessionStorage.removeItem(name)
}

/**
 * @description 存储localstorage
 * @param {存储的keyName} name
 * @param {存储的值} value
 */
export const setLocal = (name, value) => {
    if (!name) {
        return false
    }
    let data = typeof value !== 'string' ? JSON.stringify(value) : value
    window.localStorage.setItem(name, data)
}

/**
 * @description 读取localstorage
 * @param {存储的keyName} name
 */
export const getLocal = (name) => {
    if (!name) {
        return false
    }
    let data = window.localStorage.getItem(name)
    if (data) {
        return data
    } else {
        return null
    }
}

/**
 * @description 删除localstorage
 * @param {需要删除的keyName} name
 */
export const removeLocal = (name) => {
    if (!name) {
        return false
    }
    window.localStorage.removeItem(name)
}
/**
 * @description 字典转换
 * @param {*} val 值
 * @param {*} dictList 字典数组 
 * @returns 
 */
export function dictCovert(val, dictList) {
    let name = null
    for (let i = 0; i < dictList.length; i++) {
        if (dictList[i]['code'] === val) {
            name = dictList[i]['name']
            break
        }
    }
    return name
}
